import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MenuEmptyImg from 'assets/images/menu.png';

const MenuEmpty = () => {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img src={MenuEmptyImg} />
      <Typography sx={{ fontSize: '16px', fontWeight: '400', mt: 4 }}>
        Select an Item from the list for the Review
      </Typography>
      <Typography sx={{ fontSize: '14px', fontWeight: '300', mt: 1, textAlign: 'center' }}>
        Reduce your busywork and take your menu management to the next level{' '}
      </Typography>
    </Box>
  );
};

export default MenuEmpty;
